import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreditCard, CreditCardPlans, Payment, ResponseApi } from '../models/payment.model';

@Injectable({
  providedIn: 'root'
})
export class SpsDecidirApiService {
  private authHeaders: HttpHeaders;

  constructor(private httpClient: HttpClient) { }

  public makePayment(payment: Payment, access_token: string, url: string): Observable<any> {
    this._setAuthHeaders(access_token);
    return this.httpClient.post(this.normalizeUrl(url) + '/Payment', payment, { headers: this.authHeaders });
  }

  public normalizeUrl(url: string): string {
    if (url.length > 0 && url.charAt(url.length - 1) == '/') {
      url = url.substr(0, url.length - 1);
    }
    return url;
  }

  public getCreditCards(access_token: string, url: string): Observable<ResponseApi> {
    this._setAuthHeaders(access_token);
    return this.httpClient.get<ResponseApi>(this.normalizeUrl(url) + '/GetCreditCardsEnable', { headers: this.authHeaders });
  }

  public getPlansByCreditCardId(access_token: string, url: string, amount: string, creditCardId: number): Observable<ResponseApi> {
    this._setAuthHeaders(access_token);
    const body = { amount: amount, creditCardId: creditCardId };
    return this.httpClient.post<ResponseApi>(this.normalizeUrl(url) + '/CalculateAmountInInstallments', body, { headers: this.authHeaders });
  }

  private _setAuthHeaders(access_token: string) {
    const userToken = 'Bearer ' + access_token;
    this.authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': userToken });
  }
}
